import { useContent } from '../../../../hooks/use-server-content';

export interface FordRidesContentProps {
    notificationText?: string;
    notificationCtaText?: string;
    fordRidesHeading: string;
    allRidesCtaText: string;
    unassigned: string;
    business: string;
    personal: string;
    ridesText: string;
    allRidesHeading: string;
    fordRidesCtaText: string;
    filterHeadingText: string;
    filterInfoText: string;
    noRidesText: string;
    failureToFetchRide: string;
    abruptMessageText: string;
    itemsPerSection: number;
    timeOut: number;
    moreTimeTimeOut?: number;
    moreTimeMessage?: string;
    moreTimeCancelCtaText?: string;
    ridesDistanceText: string;
    asText: string;
    datePickerCtaText: string;
    ridesDurationText: string;
    ridesOdoStartText: string;
    ridesOdoEndText: string;
    ridesCategoryCtaText: string;
    toggleAccordionText: string;
    confirmModalText: string;
    confirmModalConfirmCta: string;
    confirmModalCancelCta: string;
    successStatusText: string;
    failureStatusText: string;
    itemsPerPage: number;
    pageNumberTitle: string;
    prevButtonLabel: string;
    nextButtonLabel: string;
    prevButtonTitle: string;
    nextButtonTitle: string;
    ofLabel: string;
    morePagesAriaLabel: string;
    paginationNumberList: string[];
    paginationNumberChangeText: string;
}

export const useFordRidesContent = (): FordRidesContentProps => {
    const [content, getValueByName] = useContent('ford-rides', 'ford-rides');
    const contentFragment: any = {};
    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });
    return contentFragment as FordRidesContentProps;
};
